import {post} from '../script/serviceApiPost';


export default{
  async save(requestParam: any) {
    const result = await post('funDetail/save', requestParam);
    return result;
  },
  async removeByIds(requestParam: any) {
    const result = await post('funDetail/removeByIds', requestParam);
    return result;
  },
  async updateById(requestParam: any) {
    const result = await post('funDetail/updateById', requestParam);
    return result;
  },
  async getById(requestParam: any) {
    const result = await post('funDetail/getById', requestParam);
    return result;
  },
  async selectPageData(requestParam: any) {
    const result = await post('funDetail/selectPageData', requestParam);
    return result;
  },
  async selectColumnMap(requestParam: any) {
    const result = await post('funDetail/selectColumnMap', requestParam);
    return result;
  },
  async queryOrderIsBad(requestParam: any) {
    const result = await post('funDetail/queryOrderIsBad', requestParam);
    return result;
  },
  async updateOrderNoGoFront(requestParam: any) {
    const result = await post('funDetail/updateOrderNoGoFront', requestParam);
    return result;
  },
  async updateOrderNoGoAfter(requestParam: any) {
    const result = await post('funDetail/updateOrderNoGoAfter', requestParam);
    return result;
  },
  
  
  
  
  
};
